import type { FC } from "react";

import { useConfig } from "@jti/app-context/useConfig";
import { useSelector } from "@jti/store/reduxHooks";
import { FormattedPrice, ProductMiniature } from "@jti/ui";

import type { BundleOptionValueProps } from "../BundleItem/BundleOptionValue";

import styles from "./CompactBundleItem.module.scss";

const CompactBundleOptionValue: FC<BundleOptionValueProps> = ({
  product_name,
  quantity,
  prices: { initial_price, presentation_price = null },
  imageUrl,
}) => {
  const { currency: shopCurrency } = useSelector((state) => state.cart);
  const { displayBundleSelectedItemsPrices } = useConfig();

  const renderPrices = () => {
    if (!displayBundleSelectedItemsPrices) {
      return null;
    }

    return (
      <div className={styles.bundleOptionPrice} data-testid="compactBundleProductOptionPrice">
        {presentation_price !== null && initial_price !== presentation_price ? (
          <>
            <FormattedPrice value={presentation_price} currency={shopCurrency.code} />

            <s className={styles.bundleOptionInitialPrice} data-testid="compactBundleProductOptionInitialPrice">
              <FormattedPrice value={initial_price} currency={shopCurrency.code} />
            </s>
          </>
        ) : (
          <FormattedPrice value={initial_price} currency={shopCurrency.code} />
        )}
      </div>
    );
  };

  return (
    <li className={styles.bundleOption} data-testid="compactBundleProductOption">
      {imageUrl && <ProductMiniature imageUrl={imageUrl} showTitle={false} name={product_name} />}
      <span className={styles.bundleOptionContent} data-testid="compactBundleProductOptionName">
        {quantity}&times;&nbsp;{product_name}
      </span>
      {renderPrices()}
    </li>
  );
};

export default CompactBundleOptionValue;
